const toSectionId = (value, idx) => {
  const base = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (base) return base;
  return `section-${idx + 1}`;
};

const sanitizeTextList = (value) => {
  if (!Array.isArray(value)) return [];
  return value.map((item) => String(item ?? "").trim()).filter(Boolean);
};

const sanitizeBullets = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => {
      if (item == null) return null;
      if (typeof item === "string") {
        const text = item.trim();
        return text ? text : null;
      }
      if (typeof item !== "object") {
        const text = String(item).trim();
        return text ? text : null;
      }
      const text = String(
        item.text || item.label || item.body || item.description || ""
      ).trim();
      if (!text) return null;
      const icon = String(item.icon || "").trim();
      if (!icon) return text;
      return { text, icon };
    })
    .filter(Boolean);
};

const bulletText = (bullet) =>
  typeof bullet === "string" ? bullet : String(bullet?.text || "").trim();

const sanitizeItems = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => {
      if (!item) return null;
      if (typeof item === "string") {
        const label = String(item).trim();
        if (!label) return null;
        return { label, body: "", details: [] };
      }
      const label = String(item.label || item.title || "").trim();
      const body = String(item.body || item.description || "").trim();
      const details = sanitizeTextList(item.details || item.bullets || item.notes);
      if (!label && !body && details.length === 0) return null;
      return {
        label: label || "Detail",
        body,
        details,
      };
    })
    .filter(Boolean);
};

export default function normalizeHelpSections(sections) {
  if (!Array.isArray(sections)) return [];

  const seenIds = new Set();
  return sections
    .map((section, idx) => {
      if (!section) return null;

      const title = String(section.title || section.heading || "").trim();
      const rawBullets = sanitizeBullets(section.bullets);
      let description = String(section.description || "").trim();
      let bullets = rawBullets;

      if (!description && rawBullets.length > 0) {
        description = bulletText(rawBullets[0]);
        bullets = rawBullets.slice(1);
      }

      const normalizedIdBase = String(section.id || toSectionId(title, idx));
      let normalizedId = normalizedIdBase || `section-${idx + 1}`;
      let collision = 2;
      while (seenIds.has(normalizedId)) {
        normalizedId = `${normalizedIdBase}-${collision}`;
        collision += 1;
      }
      seenIds.add(normalizedId);

      return {
        id: normalizedId,
        title: title || `Section ${idx + 1}`,
        description,
        bullets,
        tips: sanitizeTextList(section.tips),
        items: sanitizeItems(section.items),
        anchorId: String(section.anchorId || "").trim() || undefined,
      };
    })
    .filter(Boolean);
}
